import { StrictMode, lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { applySettings } from './settings/settings'
import { initTilt } from './table/tilt'
import { installProbe } from './debug/probe'
import { initPreload } from './cards/preload'
import './styles/app.css'

// `?demo` renders every screen from synthetic snapshots with no server, which
// is what makes screenshot testing tractable. It is lazy so the socket module
// is never even imported in that mode.
const DemoApp = lazy(() => import('./demo/DemoApp'))

applySettings()
initTilt()
initPreload()
installProbe()

const demo = new URLSearchParams(location.search).has('demo')

createRoot(document.getElementById('root')!).render(
  <StrictMode>{demo ? <Suspense fallback={null}><DemoApp /></Suspense> : <App />}</StrictMode>,
)
